import { Injectable } from '@angular/core';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { environment } from '@storees/environments';
import {
  VoiceCloneSampleFailedResponse,
  VoiceCloneSampleReadyResponse,
  VoiceCloneWebSocketEnvelope,
  VoiceCloneConnectedResponse,
} from '@storees/models';

type VoiceCloneSocketMessage =
  | VoiceCloneWebSocketEnvelope<VoiceCloneConnectedResponse>
  | VoiceCloneWebSocketEnvelope<VoiceCloneSampleReadyResponse>
  | VoiceCloneWebSocketEnvelope<VoiceCloneSampleFailedResponse>;

const { apiBaseUrl } = environment;

@Injectable({ providedIn: 'root' })
export class VoiceCloneSocketService {
  private socket$?: WebSocketSubject<VoiceCloneSocketMessage | { type: 'ack'; notificationId: string }>;

  connect(jwt: string): WebSocketSubject<VoiceCloneSocketMessage | { type: 'ack'; notificationId: string }> {
    const wsUrl = apiBaseUrl.replace(/^http/, 'ws');
    const url = `${wsUrl}/ws-voice-clones?token=${encodeURIComponent(jwt)}`;

    this.socket$ = webSocket({
      url,
    });

    return this.socket$;
  }

  acknowledge(notificationId: string) {
    this.socket$?.next({ type: 'ack', notificationId });
  }

  disconnect() {
    this.socket$?.complete();
    this.socket$ = undefined;
  }
}
